import { useAppSelector } from '@/utils/hook';
import { pr } from '@/utils/pxToRem';
import { Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Image from 'next/image';

const Banner = () => {
  const headerTabs = useAppSelector((state) => state.headerTabs);
  const [label, setLabel] = useState('Đặt vé máy bay giá rẻ');
  useEffect(() => {
    switch (headerTabs) {
      case 0: setLabel('Đặt vé máy bay giá rẻ'); break;
      case 1: setLabel('Đặt vé xe khách giá rẻ'); break;
      default: setLabel('Đặt vé máy bay giá rẻ');
    }
  }, [headerTabs]);

  return (
    <div style={{
      display: 'flex',
      margin: pr`16px`,
    }}
    >
      <div>
        <Image
          src={process.env.NEXT_PUBLIC_LOGO_LINK || ''}
          alt="logo"
          height={50}
          width={200}
          objectFit="contain"
        />
        <Typography
          variant="h6"
          style={{
            marginTop: pr`16px`,
            fontWeight: 'bold',
          }}
        >
          {label}
        </Typography>
      </div>
      <div style={{
        display: 'flex',
        alignItems: 'center',
      }}
      >
        <Image
          src="https://storage.googleapis.com/goyolo-production/home_icon.png"
          alt="banner"
          height={90}
          width={120}
        />
      </div>
    </div>
  );
};

export default Banner;
